module.exports = __webpack_public_path__ + "img/1F4AC.c82ca33f.svg";